/*****************
 2019-2-14, AJK, created file
******************/


import axios from 'axios';


export default {
    runScript: function(script, parameters) {
        var postData = {
            fieldData : {
            },
            script : script,
            'script.param' : parameters
        }
        return axios.post(`proxy.php?/layouts/WEB_LOG/records`, postData)
            .then((response)=>{
                console.log(response)
                return response.data
            })
            .catch((e)=>{
                if(e.response.data.messages[0].message){
                    //Return FM Error Response
                    return e.response.data
                }else{
                    //Format Unknown Error Like a FM Error
                    return  `{ messages:[message: ${e.message}, code: -1],response: {}}`;
                }
            })
    },
    downloadDocument: function(documentID){
        return axios.post(`downloadDocument.php`, documentID)
        .then((response) => {
            // success callback
            return response.data
        })
        .catch( (e) => {
            if(e.response.data.messages[0].message){
                //Return FM Error Response
                return e.response.data
            }
            else{
                //Format Unknown Error Like a FM Error
                return  `{ messages:[message: ${e.message}, code: -1],response: {}}`
            }
        })
    }
}